export function removeElement(
  parent: HTMLElement | null | undefined,
  childToRemove: HTMLElement | Element | null | undefined
) {
  if (childToRemove == null) {
    return;
  }
  if (typeof childToRemove.remove === 'function') {
    childToRemove.remove();
    return;
  }
  if (
    parent == null ||
    typeof parent.removeChild !== 'function' ||
    typeof parent.contains !== 'function'
  ) {
    return;
  }
  if (!parent.contains(childToRemove)) {
    return;
  }
  parent.removeChild(childToRemove);
}
